import ContentMod from '@/srp/SEO/ContentMod';
import useSeoData from '~/hooks/srp/useSeoData';
import { SeoProps } from '~/server-props/srp/contracts';
import ContentReviews from '../ContentReviews';
import InternalLinks from '../InternalLinkMod';

type OwnProps = {
  initialSeoProps?: SeoProps;
};

export default function ContentResultsResearch({ initialSeoProps }: OwnProps) {
  const { seoContent, seoLinks, seoReviews } = useSeoData(initialSeoProps);

  return (
    <>
      {seoContent?.contentMod ? <ContentMod contentMods={seoContent} /> : null}
      <ContentReviews contentReviews={seoReviews} />
      <InternalLinks links={seoLinks?.internalLinks} />
    </>
  );
}
